export const WHATSAPP_URL =
  "https://wa.me/5527997161009?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Previsa%20Sa%C3%BAde%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es.";

export const BRAND = {
  name: "Previsa Saúde",
  logo: "https://customer-assets.emergentagent.com/job_9516d585-db33-41dd-94ff-d4c6db66b9ab/artifacts/ihsu7vft_logomarca-previsa-saude.png",
  email: "contato@previsasaude.com.br",
  phone: "+55 27 99716 1009",
  instagram: "@previsasaude",
  instagramUrl: "https://instagram.com/previsasaude",
  linkedin: "previsasaude",
  linkedinUrl: "https://www.linkedin.com/company/previsa-saude",
  website: "previsasaude.com.br",
  address:
    "R. Erothildes Penna Medina, 195, Sala 1401, Ed. Unique Business, Praia da Costa, Vila Velha, ES, 29101-655",
};
